import { FC } from "react";
import { Box, Paper, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { dashboardStyles } from "./DashboarsStyles";

export interface CountActivityProps {
  countObject: {
    count: number;
    fontColor: string;
    icon: boolean;
    title: string;
    type: string;
  }[];
  t: (arg0: string) => string;
}

const CountActivity: FC<CountActivityProps> = ({ countObject, t }) => {
  const getIcon = (type: string) => {
    if (type === "active") {
      return (
        <Tooltip title={t("Dashboard.counts.active")} placement="right">
          <InfoOutlinedIcon sx={dashboardStyles.IconsCount} />
        </Tooltip>
      );
    }
    if (type === "inactive") {
      return (
        <Tooltip title={t("Dashboard.counts.inactive")} placement="right">
          <WarningAmberIcon sx={dashboardStyles.IconsCount} />
        </Tooltip>
      );
    }
    return null;
  };

  return (
    <Box sx={dashboardStyles.dashboardCountContainer}>
      {countObject.map((item) => (
        <Paper
          key={item.type}
          variant="outlined"
          sx={dashboardStyles.dashboardPaper}
        >
          <Box sx={dashboardStyles.dashboardItem}>
            <Typography variant="body2" color="text.secondary">
              {item.title}
            </Typography>
            {item.icon && getIcon(item.type)}
          </Box>
          <Typography
            variant="h4"
            sx={{ ...dashboardStyles.dashboardCounter, color: item.fontColor }}
          >
            {item.count}
          </Typography>
        </Paper>
      ))}
    </Box>
  );
};

export default CountActivity;
